export const question_categoryConstants = {
  REGISTER_REQUEST: 'QUESTIONS_CATEGORY_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'QUESTIONS_CATEGORY_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'QUESTIONS_CATEGORY_REGISTER_FAILURE',

  GET_REQUEST: 'QUESTIONS_CATEGORY_REQUEST',
  GET_SUCCESS: 'QUESTIONS_CATEGORY_SUCCESS',
  GET_FAILURE: 'QUESTIONS_CATEGORY_FAILURE',

  GETALL_REQUEST: 'QUESTIONS_CATEGORY_GETALL_REQUEST',
  GETALL_SUCCESS: 'QUESTIONS_CATEGORY_GETALL_SUCCESS',
  GETALL_FAILURE: 'QUESTIONS_CATEGORY_GETALL_FAILURE',

  DELETE_REQUEST: 'QUESTIONS_CATEGORY_DELETE_REQUEST',
  DELETE_SUCCESS: 'QUESTIONS_CATEGORY_DELETE_SUCCESS',
  DELETE_FAILURE: 'QUESTIONS_CATEGORY_DELETE_FAILURE',
};